/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_App_Drag_Drop_TitleInputs */

const en_nav_app_drag_drop_title = /** @type {(inputs: Nav_App_Drag_Drop_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drag & Drop`)
};

const es_nav_app_drag_drop_title = /** @type {(inputs: Nav_App_Drag_Drop_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrastra y suelta`)
};

/**
* | output |
* | --- |
* | "Drag & Drop" |
*
* @param {Nav_App_Drag_Drop_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_app_drag_drop_title = /** @type {((inputs?: Nav_App_Drag_Drop_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_App_Drag_Drop_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_app_drag_drop_title(inputs)
	return en_nav_app_drag_drop_title(inputs)
});